import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "iq-sidebar sidebar-default" }
const _hoisted_3 = { class: "iq-sidebar-logo d-flex align-items-center justify-content-between" }
const _hoisted_4 = {
  class: "data-scrollbar",
  "data-scroll": "1"
}
const _hoisted_5 = { class: "iq-sidebar-menu" }
const _hoisted_6 = {
  id: "iq-sidebar-toggle",
  class: "iq-menu"
}
const _hoisted_7 = { class: "active" }
const _hoisted_8 = {
  id: "otherpage",
  class: "iq-submenu collapse",
  "data-parent": "#iq-sidebar-toggle"
}
const _hoisted_9 = {
  id: "user",
  class: "iq-submenu collapse",
  "data-parent": "#otherpage"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "iq-top-navbar" }
const _hoisted_14 = { class: "iq-navbar-custom" }
const _hoisted_15 = { class: "navbar navbar-expand-lg navbar-light p-0" }
const _hoisted_16 = { class: "iq-navbar-logo d-flex align-items-center justify-content-between" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_19 = { class: "navbar-nav ml-auto navbar-list align-items-center" }
const _hoisted_20 = { class: "nav-item nav-icon dropdown" }
const _hoisted_21 = {
  href: "#",
  class: "search-toggle dropdown-toggle",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_22 = {
  key: 0,
  class: "bg-primary count-mail"
}
const _hoisted_23 = {
  class: "iq-sub-dropdown dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_24 = { class: "card shadow-none m-0" }
const _hoisted_25 = { class: "card-body p-0" }
const _hoisted_26 = { class: "cust-title p-3" }
const _hoisted_27 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_28 = {
  key: 0,
  class: "badge badge-primary badge-card"
}
const _hoisted_29 = {
  key: 0,
  class: "text-center p-3"
}
const _hoisted_30 = {
  key: 1,
  class: "text-center p-3"
}
const _hoisted_31 = {
  key: 2,
  class: "px-3 pt-0 pb-0 sub-card"
}
const _hoisted_32 = { class: "media align-items-center cust-card py-3 border-bottom" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "media-body ml-3" }
const _hoisted_35 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "text-dark" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "nav-item nav-icon dropdown caption-content" }
const _hoisted_40 = {
  class: "iq-sub-dropdown dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_41 = { class: "card shadow-none m-0" }
const _hoisted_42 = { class: "card-body p-0 text-center" }
const _hoisted_43 = { class: "p-3" }
const _hoisted_44 = { class: "mb-1" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = { class: "d-flex align-items-center justify-content-center mt-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  class: "modal fade",
  id: "new-order",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_49 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "popup text-left" }
const _hoisted_53 = { class: "content create-workform bg-body" }
const _hoisted_54 = { class: "pb-3" }
const _hoisted_55 = { class: "input-group" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "input-group-append" }
const _hoisted_58 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: _ctx.dashboardRoute,
            class: "header-logo"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("h5", { class: "logo-title light-logo ml-3" }, "Dalto Investments", -1)
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "iq-menu-bt-sidebar ml-0" }, [
            _createElementVNode("i", { class: "las la-bars wrapper-menu" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/dashboard",
                      class: "svg-icon"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          class: "svg-icon",
                          id: "p-dash1",
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
                          _createElementVNode("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "22.08",
                            x2: "12",
                            y2: "12"
                          })
                        ], -1),
                        _createElementVNode("span", { class: "ml-4" }, "Quick Access", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/",
                      class: "svg-icon"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("svg", {
                          class: "svg-icon",
                          id: "p-dash1",
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
                          _createElementVNode("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "22.08",
                            x2: "12",
                            y2: "12"
                          })
                        ], -1),
                        _createElementVNode("span", { class: "ml-4" }, "Quick Access", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/wallet-deposit-admin"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("svg", {
                          class: "svg-icon",
                          id: "p-dash3",
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("rect", {
                            x: "9",
                            y: "9",
                            width: "13",
                            height: "13",
                            rx: "2",
                            ry: "2"
                          }),
                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
                        ], -1),
                        _createElementVNode("span", { class: "ml-4" }, "Deposits", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/wallet-deposit"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("svg", {
                          class: "svg-icon",
                          id: "p-dash3",
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("rect", {
                            x: "9",
                            y: "9",
                            width: "13",
                            height: "13",
                            rx: "2",
                            ry: "2"
                          }),
                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
                        ], -1),
                        _createElementVNode("span", { class: "ml-4" }, "Deposits", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _cache[17] || (_cache[17] = _createStaticVNode("<a href=\"#otherpage\" class=\"collapsed\" data-toggle=\"collapse\" aria-expanded=\"false\" data-v-456d258f><svg class=\"svg-icon\" id=\"p-dash9\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-456d258f><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" data-v-456d258f></rect><rect x=\"7\" y=\"7\" width=\"3\" height=\"9\" data-v-456d258f></rect><rect x=\"14\" y=\"7\" width=\"3\" height=\"5\" data-v-456d258f></rect></svg><span class=\"ml-4\" data-v-456d258f>Accounts</span><svg class=\"svg-icon iq-arrow-right arrow-active\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-456d258f><polyline points=\"10 15 15 20 20 15\" data-v-456d258f></polyline><path d=\"M4 4h7a4 4 0 0 1 4 4v12\" data-v-456d258f></path></svg></a>", 1)),
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _cache[16] || (_cache[16] = _createStaticVNode("<a href=\"#user\" class=\"collapsed\" data-toggle=\"collapse\" aria-expanded=\"false\" data-v-456d258f><svg class=\"svg-icon\" id=\"p-dash10\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-456d258f><path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\" data-v-456d258f></path><circle cx=\"8.5\" cy=\"7\" r=\"4\" data-v-456d258f></circle><polyline points=\"17 11 19 13 23 9\" data-v-456d258f></polyline></svg><span class=\"ml-4\" data-v-456d258f>My Transactions</span><svg class=\"svg-icon iq-arrow-right arrow-active\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-456d258f><polyline points=\"10 15 15 20 20 15\" data-v-456d258f></polyline><path d=\"M4 4h7a4 4 0 0 1 4 4v12\" data-v-456d258f></path></svg></a>", 1)),
                    _createElementVNode("ul", _hoisted_9, [
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                            _createVNode(_component_router_link, { to: "/network-address" }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "las la-minus" }, null, -1),
                                _createElementVNode("span", null, "Network & Wallet Address", -1)
                              ])),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createVNode(_component_router_link, { to: "/investment-interest" }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("i", { class: "las la-minus" }, null, -1),
                                _createElementVNode("span", null, "Interest Rate", -1)
                              ])),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                            _createVNode(_component_router_link, { to: "/my-referral-users" }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "las la-minus" }, null, -1),
                                _createElementVNode("span", null, "My Referrall Users", -1)
                              ])),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/return-on-investment" }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "las la-minus" }, null, -1),
                            _createElementVNode("span", null, "Investment Profit", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/withdraw-transctions" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "las la-minus" }, null, -1),
                            _createElementVNode("span", null, "Withdraw Transactions", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        (!_ctx.isAdmin)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/deposit-transactions"
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createElementVNode("i", { class: "las la-minus" }, null, -1),
                                _createElementVNode("span", null, "Deposits Transactions", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/user-profile" }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "las la-minus" }, null, -1),
                            _createElementVNode("span", null, "My Profile", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/create-notification"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "las la-minus" }, null, -1),
                                _createElementVNode("span", null, "Create Notification", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _cache[18] || (_cache[18] = _createStaticVNode("<div id=\"sidebar-bottom\" class=\"position-relative sidebar-bottom\" data-v-456d258f><div class=\"card border-none\" data-v-456d258f><div class=\"card-body p-0\" data-v-456d258f><div class=\"sidebarbottom-content\" data-v-456d258f><div class=\"image\" data-v-456d258f><img src=\"assets/images/logo-dalto.jpeg\" class=\"img-fluid\" alt=\"side-bkg\" data-v-456d258f></div><h6 class=\"mt-4 px-4 body-title\" data-v-456d258f> Get Rewarded for Referring Friends </h6><button type=\"button\" class=\"btn sidebar-bottom-btn mt-4\" data-toggle=\"modal\" data-target=\"#new-order\" data-v-456d258f> Refer To Friends </button></div></div></div></div><div class=\"p-3\" data-v-456d258f></div>", 2))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("nav", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "ri-menu-line wrapper-menu" }, null, -1)),
              _createVNode(_component_router_link, {
                to: _ctx.dashboardRoute,
                class: "header-logo"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("img", {
                    src: "assets/images/logo.png",
                    class: "img-fluid rounded-normal",
                    alt: "logo"
                  }, null, -1),
                  _createElementVNode("h5", { class: "logo-title ml-3" }, "Dalto Investments", -1)
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"iq-search-bar device-search\" data-v-456d258f><form action=\"#\" class=\"searchbox\" data-v-456d258f><a class=\"search-link\" href=\"#\" data-v-456d258f><i class=\"ri-search-line\" data-v-456d258f></i></a><input type=\"text\" class=\"text search-input\" placeholder=\"Search here...\" data-v-456d258f></form></div>", 1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[30] || (_cache[30] = _createElementVNode("button", {
                class: "navbar-toggler",
                type: "button",
                "data-toggle": "collapse",
                "data-target": "#navbarSupportedContent",
                "aria-controls": "navbarSupportedContent",
                "aria-label": "Toggle navigation"
              }, [
                _createElementVNode("i", { class: "ri-menu-3-line" })
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ul", _hoisted_19, [
                  _cache[29] || (_cache[29] = _createStaticVNode("<li class=\"nav-item nav-icon dropdown\" data-v-456d258f><a href=\"#\" class=\"search-toggle dropdown-toggle btn border add-btn\" id=\"dropdownMenuButton02\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-v-456d258f><img src=\"assets/images/small/flag-01.png\" alt=\"img-flag\" class=\"img-fluid image-flag mr-2\" data-v-456d258f>En </a><div class=\"iq-sub-dropdown dropdown-menu\" aria-labelledby=\"dropdownMenuButton2\" data-v-456d258f><div class=\"card shadow-none m-0\" data-v-456d258f><div class=\"card-body p-3\" data-v-456d258f><a class=\"iq-sub-card\" href=\"#\" data-v-456d258f><img src=\"assets/images/small/flag-02.png\" alt=\"img-flag\" class=\"img-fluid mr-2\" data-v-456d258f>French</a><a class=\"iq-sub-card\" href=\"#\" data-v-456d258f><img src=\"assets/images/small/flag-03.png\" alt=\"img-flag\" class=\"img-fluid mr-2\" data-v-456d258f>Spanish</a><a class=\"iq-sub-card\" href=\"#\" data-v-456d258f><img src=\"assets/images/small/flag-04.png\" alt=\"img-flag\" class=\"img-fluid mr-2\" data-v-456d258f>Italian</a><a class=\"iq-sub-card\" href=\"#\" data-v-456d258f><img src=\"assets/images/small/flag-05.png\" alt=\"img-flag\" class=\"img-fluid mr-2\" data-v-456d258f>German</a><a class=\"iq-sub-card\" href=\"#\" data-v-456d258f><img src=\"assets/images/small/flag-06.png\" alt=\"img-flag\" class=\"img-fluid mr-2\" data-v-456d258f>Japanese</a></div></div></div></li><li data-v-456d258f><a href=\"#\" class=\"btn border add-btn shadow-none mx-2 d-none d-md-block\" data-toggle=\"modal\" data-target=\"#new-order\" data-v-456d258f><i class=\"las la-plus mr-2\" data-v-456d258f></i>Referral Promo Code </a></li><li class=\"nav-item nav-icon search-content\" data-v-456d258f><a href=\"#\" class=\"search-toggle rounded\" id=\"dropdownSearch\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-v-456d258f><i class=\"ri-search-line\" data-v-456d258f></i></a><div class=\"iq-search-bar iq-sub-dropdown dropdown-menu\" aria-labelledby=\"dropdownSearch\" data-v-456d258f><form action=\"#\" class=\"searchbox p-2\" data-v-456d258f><div class=\"form-group mb-0 position-relative\" data-v-456d258f><input type=\"text\" class=\"text search-input font-size-12\" placeholder=\"type here to search...\" data-v-456d258f><a href=\"#\" class=\"search-link\" data-v-456d258f><i class=\"las la-search\" data-v-456d258f></i></a></div></form></div></li>", 3)),
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", _hoisted_21, [
                      _cache[21] || (_cache[21] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "feather feather-bell"
                      }, [
                        _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
                        _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
                      ], -1)),
                      (_ctx.unreadCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.unreadCount), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "mb-0" }, "Notifications", -1)),
                              (_ctx.unreadCount > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.unreadCount), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.loadingNotifications)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[23] || (_cache[23] = [
                                _createElementVNode("div", {
                                  class: "spinner-border text-primary",
                                  role: "status"
                                }, [
                                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                ], -1)
                              ])))
                            : (_ctx.recentNotifications.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[24] || (_cache[24] = [
                                  _createElementVNode("small", null, "No notifications available", -1)
                                ])))
                              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentNotifications, (notification) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      key: notification.id,
                                      to: { name: 'SingleNotification', params: { id: notification.id } },
                                      class: "iq-sub-card"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("img", {
                                              class: "avatar-50 rounded-small",
                                              src: notification.sender?.avatar || 'assets/images/user/01.jpg',
                                              alt: "sender"
                                            }, null, 8, _hoisted_33)
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("div", _hoisted_35, [
                                              _createElementVNode("h6", _hoisted_36, _toDisplayString(notification.title), 1),
                                              _createElementVNode("small", _hoisted_37, [
                                                _createElementVNode("b", null, _toDisplayString(new Date(notification.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })), 1)
                                              ])
                                            ]),
                                            _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.truncateMessage(notification.message, 30)), 1)
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  }), 128))
                                ])),
                          _createVNode(_component_router_link, {
                            class: "right-ic btn btn-primary btn-block position-relative p-2",
                            to: "/notifications",
                            role: "button"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" View All ")
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_39, [
                    _cache[28] || (_cache[28] = _createElementVNode("a", {
                      href: "#",
                      class: "search-toggle dropdown-toggle",
                      id: "dropdownMenuButton4",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("img", {
                        src: "assets/images/user/1.png",
                        class: "img-fluid rounded",
                        alt: "user"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "media-body profile-detail text-center" }, [
                            _createElementVNode("img", {
                              src: "assets/images/logo-dalto.jpeg",
                              alt: "profile-bg",
                              class: "rounded-top img-fluid mb-4"
                            }),
                            _createElementVNode("img", {
                              src: "assets/images/user/1.png",
                              alt: "profile-img",
                              class: "rounded profile-img img-fluid avatar-70"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.userData?.email || "-"), 1),
                            _createElementVNode("p", _hoisted_45, " Since " + _toDisplayString(_ctx.userData?.created_at
                                ? new Date(_ctx.userData.created_at).toLocaleDateString()
                                : "N/A"), 1),
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_router_link, {
                                to: "/user-profile",
                                class: "btn border mr-2"
                              }, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode("Profile")
                                ])),
                                _: 1
                              }),
                              _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                                class: "btn border",
                                disabled: _ctx.loggingOut
                              }, _toDisplayString(_ctx.loggingOut ? "Signing Out..." : "Sign Out"), 9, _hoisted_47)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "mb-3" }, " Copy Your Promo Code and Share to Your Friends to Get Rewarded ", -1)),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "mb-2" }, "Your Referral Promo Code", -1)),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("input", {
                        type: "text",
                        value: _ctx.referralPromoCode,
                        class: "form-control",
                        placeholder: "Your Promo Code",
                        readonly: ""
                      }, null, 8, _hoisted_56),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-primary",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyPromoCode && _ctx.copyPromoCode(...args))),
                          disabled: _ctx.isCopying
                        }, [
                          _cache[32] || (_cache[32] = _createElementVNode("i", { class: "ri-file-copy-line" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.isCopying ? 'Copying...' : 'Copy'), 1)
                        ], 8, _hoisted_58)
                      ])
                    ])
                  ]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-lg-12 mt-4" }, [
                    _createElementVNode("div", { class: "d-flex flex-wrap align-items-center justify-content-center" })
                  ], -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_router_view, { name: "global" })
    ]),
    _cache[36] || (_cache[36] = _createStaticVNode("<footer class=\"iq-footer\" data-v-456d258f><div class=\"container-fluid\" data-v-456d258f><div class=\"card\" data-v-456d258f><div class=\"card-body\" data-v-456d258f><div class=\"row\" data-v-456d258f><div class=\"col-lg-6\" data-v-456d258f><ul class=\"list-inline mb-0\" data-v-456d258f><li class=\"list-inline-item\" data-v-456d258f><a href=\"#\" data-v-456d258f>Privacy Policy</a></li><li class=\"list-inline-item\" data-v-456d258f><a href=\"#\" data-v-456d258f>Terms of Use</a></li></ul></div><div class=\"col-lg-6 text-right\" data-v-456d258f><span class=\"mr-1\" data-v-456d258f> © </span><a href=\"#\" class=\"\" data-v-456d258f>Dalto Investments</a>. </div></div></div></div></div></footer>", 1))
  ], 64))
}